// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-367b4e8c] .el-table th.el-table__cell.is-leaf{border-bottom:none!important}[data-v-367b4e8c] .el-icon-close{font-size:18px}", ""]);
// Exports
module.exports = exports;
